import React from "react";
import { Modal, Button, Space } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

const RoleSelectorModal = ({ open, roles, activeRoleId, onSelectRole }) => {
  return (
    <Modal
      open={open}
      title="Pilih Role"
      footer={null}
      closable={false}
      centered
      width={300}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        {roles.map((role) => {
          const isActive = role.is_used === "1";

          return (
            <Button
              key={role.role_id}
              type={isActive ? "primary" : "default"}
              block
              onClick={() => onSelectRole(role.role_id)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "200px",
                  display: "block",
                }}
              >
                {role.role_nama}
              </span>
              {isActive && <CheckCircleOutlined />}
            </Button>
          );
        })}
      </Space>
    </Modal>
  );
};

export default RoleSelectorModal;
